module.exports = __webpack_public_path__ + "images/coursera-img2.jpg";